/*****************************************
 * * IMPORTS
 *****************************************/
// React libraries
import React, { Component } from 'react';

// styles and images

// styles and images
import plusImg from '../../assets/icons/plus.svg';
import minusImg from '../../assets/icons/minus.svg';
import playImg from '../../assets/icons/play.svg';
import pauseImg from '../../assets/icons/pause.svg';
import repeatBtnImg from '../../assets/icons/repeat.svg';
import spinImg from '../../assets/icons/spin.webp';
import styles from './Main.module.css';

// components

import Select from '../buttons/Select';
import StepSlider from '../buttons/StepSlider';
import ImgBtn from '../buttons/ImgBtn';
import Graphics from '../graphics/Graphics';

// code
import data, { uiData } from '../../logic/data';
import calcFunctions from '../../logic/gen-content';
import { play, createAnimation } from '../../logic/process';

/*****************************************
 * * CREATE COMPONENT
 *****************************************/

class Main extends Component {
  state = {
    exampleIdx: data.exampleIdx,
    playState: 'pause',
    sliderData: data.examples[0].sliderData,
    speed: data.examples[0].speed,
    timeScale: data.examples[0].sliderData.initTimeScale,
    viewBox: data.examples[0].viewBox,
    content: calcFunctions.createContent[0].createContent(),
    anim: calcFunctions.createContent[0].createAnim,
  };
  hida = 4;

  componentDidMount() {
    setTimeout(createAnimation.bind(this), 0);
  }

  // slider change
  handleSliderChange = val => {
    this.setState({ timeScale: val });
  };

  handleMinusClick = () => {
    const { minTimeScale, stepTimeScale } = this.state.sliderData;
    let timeScale = this.state.speed;
    if (timeScale > minTimeScale) {
      timeScale -= stepTimeScale;
    }
    this.handleSliderChange(timeScale);
  };

  handlePlusClick = () => {
    const { maxTimeScale, stepTimeScale } = this.state.sliderData;
    let timeScale = this.state.speed;
    if (timeScale < maxTimeScale) {
      timeScale += stepTimeScale;
    }
    this.handleSliderChange(timeScale);
  };

  // change playing example
  handleExampleChange = val => {
    // console.log('[EXAMPLE]', val);
    this.props.onExampleChange(val);
    
    this.setState({
      playState: 'pause',
      playClickDisable: val !== this.hida ? false : true,
      exampleIdx: val,
      sliderData: data.examples[val].sliderData,
      speed: data.examples[val].speed,
      timeScale: data.examples[val].sliderData.initTimeScale,

      content: calcFunctions.createContent[val].createContent(),
      anim: calcFunctions.createContent[val].createAnim,
      viewBox: data.examples[val].viewBox,
    });
    setTimeout(createAnimation.bind(this), 0);
  };

  // play/pause was clicked
  onPlayClick = () => {
    setTimeout(play.bind(this), 0);
  };

  // HTML code
  render() {
    const playBtnImg = this.state.playState === 'play' ? pauseImg : playImg;
    const { minTimeScale, maxTimeScale, stepTimeScale } = this.state.sliderData;
    const { content, speed, timeScale, viewBox, anim } = this.state;

    return (
      <main className={styles.main}>
        <Graphics
          onRef={ref => (this.svg = ref)}
          content={content}
          viewBox={viewBox}
          speed={speed}
          timeScale={timeScale}
          anim={anim}
        />

        {/* inputs */}
        <div className={styles.slider}>
          <ImgBtn src={plusImg} onClick={this.handlePlusClick} small={true} />

          <StepSlider
            title='מהירות'
            onChange={this.handleSliderChange}
            marks
            min={minTimeScale}
            max={maxTimeScale}
            step={stepTimeScale}
            value={timeScale}
            valueLabelDisplay='on'
          />
          <ImgBtn src={minusImg} onClick={this.handleMinusClick} small={true} />
        </div>

        <div className={styles.inputs}>
          <ImgBtn
            src={playBtnImg}
            onClick={this.onPlayClick}
            disabled={this.state.playClickDisable}
            // dataToolTip="play/pause"
          />

          <Select
            options={uiData.selectOptions}
            selectedIdx={this.state.exampleIdx}
            onSelectChange={this.handleExampleChange}
          />
        </div>
      </main>
    );
  }
}

export default Main;
